// Check if today is user's birthday (day & month match)
export const isBirthdayToday = (dob) => {
  if (!dob) return false;

  const today = new Date();

  // Extract UTC day/month from the DOB
  const birthDay = dob.getUTCDate();
  const birthMonth = dob.getUTCMonth(); // 0-indexed

  const todayDay = today.getDate();
  const todayMonth = today.getMonth();

  return birthDay === todayDay && birthMonth === todayMonth;
};

// Calculate dynamic age
export const calculateAge = (dob) => {
  if (!dob) return 0;

  const today = new Date();

  const birthYear = dob.getUTCFullYear();
  const birthMonth = dob.getUTCMonth();
  const birthDay = dob.getUTCDate();

  let age = today.getFullYear() - birthYear;

  // Subtract 1 if birthday hasn't occurred yet this year
  if (
    today.getMonth() < birthMonth ||
    (today.getMonth() === birthMonth && today.getDate() < birthDay)
  ) {
    age--;
  }

  return age;
};


